import { t } from './sprache'

/**
 * **Ein umgehängtes oder stillgelegtes Element sagt, bis wann es galt**
 * (7.3 Abschnitt 33, R1724, R1725).
 *
 * Der Auftrag vom 2026-10-14: *„Wenn ich ein Konto im Zeitverlauf umhänge,
 * soll das alte Element einen dezenten Namenszusatz per System bekommen, damit
 * für den Anwender erkennbar ist, dass dies ein stillgelegtes Element ist und
 * bis wann es gültig war."* Nur das alte Element trägt ihn.
 *
 * **Abgeleitet, nicht gespeichert:** Der Dienst nennt den letzten Monat aus dem
 * Ende der Einhängung oder der Stilllegung, gelesen zum Stand des Berichts.
 * Hier wird er nur geschrieben — an einer Stelle für jede Anzeige.
 */

/** Der Monat in der Schreibweise des Zusatzes — `202609` → `09.2026`. */
export function bisMonat(bis: number): string {
  return `${String(bis % 100).padStart(2, '0')}.${Math.floor(bis / 100)}`
}

/** Der letzte Monat vor einer Stilllegung — stillgelegt ab `202610` heißt bis `202609`. */
export function bisVorStilllegung(stillgelegtAb: number): number {
  return stillgelegtAb % 100 === 1 ? (Math.floor(stillgelegtAb / 100) - 1) * 100 + 12 : stillgelegtAb - 1
}

/** Der Zusatz als Text — „· bis 09.2026"; leer ohne Ende. */
export function bisZusatz(bis: number | null | undefined): string {
  return bis ? t('bis.zusatz', { monat: bisMonat(bis) }) : ''
}

/** Ein Name mit Zusatz — für Titel und Menüs, wo nur Text steht. */
export function mitBis(name: string, bis: number | null | undefined): string {
  return bis ? `${name} ${bisZusatz(bis)}` : name
}

/** Der Zusatz dezent hinter einem Namen — nichts ohne Ende. */
export function Bisvermerk({ bis }: { bis?: number | null }) {
  return bis ? <span className="bisvermerk">{bisZusatz(bis)}</span> : null
}
